export function isNullOrUndefined<T>(value: T): boolean {
    return value === undefined || value === null;
}
